// @noflow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';

import { periods } from '~/core/constants';
import { padNumber } from '~/core/utils/numbers';
import messages from './intl';

export function getStartEndTimeFromPeriod(period, now = moment()) {
    const periodFnLookup = {
        [periods.TODAY.constant]: () => getDayStartEndTimes(now),
        [periods.YESTERDAY.constant]: () => getDayStartEndTimes(now, -1),
        [periods.THIS_WEEK.constant]: () => getWeekStartEndTimes(now),
        [periods.LAST_WEEK.constant]: () => getWeekStartEndTimes(now, -1),
        [periods.THIS_MONTH.constant]: () => getMonthStartEndTimes(now),
        [periods.LAST_MONTH.constant]: () => getMonthStartEndTimes(now, -1),
        [periods.THIS_YEAR.constant]: () => getYearStartEndTimes(now)
    };

    return periodFnLookup[period.constant]();
}

function getDayStartEndTimes(now, dayOffset = 0) {
    const startOfDay = moment(now)
        .startOf('day')
        .add(dayOffset, 'd')
        .startOf('day');
    const endOfDay = moment(startOfDay).endOf('day');

    return {
        start: startOfDay,
        end: endOfDay
    };
}

function getWeekStartEndTimes(now, weekOffset = 0) {
    const startOfWeek = moment(now)
        .add(weekOffset, 'w')
        .startOf('week')
        .add(-1, 'd');
    const endOfWeek =
        weekOffset === 0
            ? moment(now)
            : moment(startOfWeek)
                  .add(1, 'd')
                  .endOf('week')
                  .add(-1, 'd');
    return {
        start: startOfWeek,
        end: endOfWeek
    };
}

function getMonthStartEndTimes(now, monthOffset = 0) {
    const startOfMonth = moment(now)
        .add(monthOffset, 'M')
        .startOf('month');
    const endOfMonth = monthOffset === 0 ? moment(now) : moment(startOfMonth).endOf('month');
    return {
        start: startOfMonth,
        end: endOfMonth
    };
}

function getYearStartEndTimes(now, yearOffset = 0) {
    const startOfYear = moment(now)
        .add(yearOffset, 'y')
        .startOf('year');
    const endOfYear = yearOffset === 0 ? moment(now) : moment(startOfYear).endOf('year');

    return {
        start: startOfYear,
        end: endOfYear
    };
}

export const daysBetween = (start, end) => {
    const startOfFinish = moment(end).startOf('day');
    let current = moment(start).startOf('day');

    const days = [];
    while (current.isSameOrBefore(startOfFinish)) {
        days.push(current);
        current = moment(current).add(1, 'day');
    }

    return days;
};

export const customDuration = (start, end) => {
    const duration = moment.duration(end - start);
    let message;

    if (duration.asSeconds() < 1) message = messages.durationMiliseconds;
    else if (duration.asHours() >= 1) message = messages.durationHours;
    else message = messages.durationMinutes;

    return (
        <FormattedMessage
            {...message}
            values={{
                hours: Math.floor(duration.asHours()),
                minutes: padNumber(Math.floor(duration.asMinutes())),
                seconds: padNumber(duration.seconds())
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/core/utils/periods/index.js